exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-description{color:#686868;font-size:13px;padding-top:1px;padding-left:2%;padding-right:2%;margin:0 auto;text-align:justify}#header-div{max-width:960px;margin-left:auto;margin-right:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af0a646c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/resume/Resume.vue
// module id = 1094
// module chunks = 0